<div class="modal-header bg-dark text-white">
  <h3 class="modal-title" id="modal-basic-title">Import Airport Location Requirements from Excel</h3>
  <div class="ms-auto" data-bs-theme="dark">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
  </div>
</div>
<div class="modal-body">
  <!-- Before import: instructions and dropzone -->
  <div *ngIf="!showResults && !showValidationResults">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM14.828 12.709c-0.589 0.458-1.134 0.77-1.635 0.934v1.742c0.953-0.314 1.781-0.799 2.484-1.455v7.111h2.047v-10h-1.686c-0.218 0.612-0.622 1.209-1.21 1.668z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            <div [hidden]="loadingTemplate">
              Download <a (click)="downloadTemplate($event)" href="#" class=""><strong>Tender Location Import
                  Template.xlsx</strong></a>
            </div>

            <div [hidden]="!loadingTemplate">
              <button class="btn btn-outline-dark" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                <span role="status" class="ms-2">Generating Excel Template</span>
              </button>
              <p class="text-muted small mb-0">Please wait, time may vary depending on the number of tender locations.
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number1</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM17.564 17.777c0.607-0.556 1.027-0.982 1.26-1.278 0.351-0.447 0.607-0.875 0.77-1.282 0.161-0.408 0.242-0.838 0.242-1.289 0-0.793-0.283-1.457-0.848-1.99s-1.342-0.8-2.331-0.8c-0.902 0-1.654 0.23-2.256 0.69s-0.96 1.218-1.073 2.275l1.914 0.191c0.036-0.56 0.173-0.96 0.41-1.201s0.555-0.361 0.956-0.361c0.405 0 0.723 0.115 0.952 0.345 0.23 0.23 0.346 0.56 0.346 0.988 0 0.387-0.133 0.779-0.396 1.176-0.195 0.287-0.727 0.834-1.592 1.64-1.076 0.998-1.796 1.799-2.16 2.403s-0.584 1.242-0.656 1.917h6.734v-1.781h-3.819c0.101-0.173 0.231-0.351 0.394-0.534 0.16-0.183 0.545-0.552 1.153-1.109z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            Add location information to the Excel template
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <svg class="svg-fill-dark" width="64px" height="64px" viewBox="0 0 32 32" version="1.1"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <title>number2</title>
                <path
                  d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM17.248 15.219c0.963-0.525 1.443-1.228 1.443-2.108 0-0.621-0.234-1.177-0.705-1.67-0.571-0.602-1.33-0.903-2.275-0.903-0.553 0-1.052 0.104-1.497 0.311s-0.792 0.493-1.042 0.855c-0.248 0.362-0.435 0.847-0.559 1.454l1.773 0.302c0.051-0.439 0.193-0.772 0.426-1.001s0.516-0.343 0.845-0.343c0.334 0 0.603 0.101 0.804 0.301 0.201 0.201 0.302 0.471 0.302 0.809 0 0.398-0.138 0.716-0.413 0.957-0.273 0.24-0.673 0.353-1.195 0.339l-0.213 1.565c0.344-0.096 0.638-0.144 0.885-0.144 0.374 0 0.691 0.141 0.952 0.423s0.391 0.665 0.391 1.147c0 0.509-0.136 0.914-0.407 1.214s-0.607 0.45-1.004 0.45c-0.37  0-0.686-0.125-0.945-0.375-0.261-0.25-0.42-0.612-0.479-1.086l-1.859 0.226c0.096 0.843 0.442 1.525 1.040 2.047s1.35 0.782 2.258 0.782c0.957 0 1.758-0.309 2.401-0.929s0.965-1.368 0.965-2.247c0-0.605-0.172-1.122-0.515-1.55-0.346-0.427-0.804-0.703-1.377-0.826z">
                </path>
              </g>
            </svg>
          </div>
          <div class="flex-grow-1 ms-3">
            Import the updated template with location data below
          </div>
        </div>
      </li>
    </ul>
    <form>
      <div class="form-group">
        <jft-dropzone (filesSelected)="filesSelected($event)" [loading]="loading">
          Drop <strong>Tender Location Import Template.xlsx</strong> here
        </jft-dropzone>
      </div>
    </form>
  </div>

  <!-- Validation Results -->
  <div *ngIf="showValidationResults">
    <!-- Template validation errors section (e.g., missing required columns) -->
    <div *ngIf="validationErrors?.length" class="alert alert-danger" role="alert">
      <h5 class="alert-heading mb-2">
        <ng-icon name="lucideTriangleAlert"></ng-icon>
        Template Validation Failed
      </h5>
      <div *ngFor="let error of validationErrors" class="mb-2">
        <p class="mb-0">{{ error }}</p>
      </div>
      <hr>
      <div class="d-flex align-items-center">
        <button *ngIf="!loadingTemplate" type="button" class="btn btn-outline-primary" (click)="downloadTemplate($event)">
          <ng-icon name="lucideDownload" class="me-1"></ng-icon>
          Download New Template
        </button>
        <button *ngIf="loadingTemplate" type="button" class="btn btn-outline-primary" disabled>
          <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
          Generating Template...
        </button>
      </div>
    </div>

    <!-- Validation success when no errors -->
    <div *ngIf="!validationErrors?.length && !validationStats?.locations_skipped_due_to_other_errors?.length"
      class="alert alert-success">
      <h5 class="alert-heading mb-2">
        <ng-icon name="lucideBadgeCheck"></ng-icon>
        Validation Passed
      </h5>
      <p class="mb-0">
        Your Excel file has been validated successfully.
        <span *ngIf="validationStats?.locations_valid?.length">
          {{ validationStats.locations_valid.length }} locations will be added.
        </span>
        <span *ngIf="validationStats?.locations_duplicates?.length">
          {{ validationStats.locations_duplicates.length }} duplicate row(s) will update existing contracts.
        </span>
      </p>
    </div>

    <!-- Partial validation when some locations are skipped -->
    <div *ngIf="!validationErrors?.length && validationStats?.locations_skipped_due_to_other_errors?.length"
      class="alert alert-warning">
      <h5 class="alert-heading mb-2">
        <ng-icon name="lucideTriangleAlert"></ng-icon>
        Partial Validation Issues
      </h5>
      <p class="mb-0">
        Some locations have valid data but will be skipped because other locations in the file have validation errors.
        Fix the validation errors below to import all locations.
      </p>
    </div>

    <!-- Validation summary cards -->
    <div class="row g-3 mb-3" *ngIf="validationStats">
      <div class="col-md-3">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0">{{ validationStats.total_locations_found ?? 0 }}</div>
            <div class="text-muted">Total Rows Found</div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0">{{ validationStats.locations_valid?.length || 0 }}</div>
            <div class="text-muted">Will Import</div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0">{{ validationStats.locations_duplicates?.length || 0 }}</div>
            <div class="text-muted">Will Update</div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0">{{ (validationStats.locations_with_errors?.length || 0) +
              (validationStats.locations_skipped_due_to_other_errors?.length || 0) }}</div>
            <div class="text-muted">Will Skip</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Duplicate locations info -->
    <div *ngIf="validationStats?.locations_duplicates?.length" class="mb-3">
      <div class="alert alert-info">
        <h6 class="alert-heading mb-2">
          <ng-icon name="lucideInfo"></ng-icon>
          Duplicate Rows Detected
        </h6>
        <p class="mb-2">The following rows contain duplicate location data and will update existing contracts instead of
          creating new ones:</p>
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-sm table-striped align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Row</th>
                    <th>IATA</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let duplicate of validationStats.locations_duplicates">
                    <td>{{ duplicate.row || '-' }}</td>
                    <td><strong>{{ duplicate.iata || '-' }}</strong></td>
                    <td class="text-muted">{{ duplicate.reason || 'Will update existing contract' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Validation errors details -->
    <div *ngIf="validationStats?.locations_with_errors?.length" class="mb-3">
      <div class="card">
        <div class="card-header bg-warning text-dark">Rows with Validation Issues</div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-sm table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>Row</th>
                  <th>IATA</th>
                  <th>Issue</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of validationStats.locations_with_errors">
                  <td>{{ error.row || '-' }}</td>
                  <td><strong>{{ error.iata || '-' }}</strong></td>
                  <td [innerHTML]="error.reason || '-'"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Locations skipped due to other errors -->
    <div *ngIf="validationStats?.locations_skipped_due_to_other_errors?.length" class="mb-3">
      <div class="alert alert-info">
        <h6 class="alert-heading mb-2">
          <ng-icon name="lucideInfo"></ng-icon>
          Valid Locations Skipped
        </h6>
        <p class="mb-2">The following locations have valid data but will be skipped because other locations in the file
          have validation errors:</p>
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-sm table-striped align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Row</th>
                    <th>IATA</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let skipped of validationStats.locations_skipped_due_to_other_errors">
                    <td>{{ skipped.row || '-' }}</td>
                    <td><strong>{{ skipped.iata || '-' }}</strong></td>
                    <td class="text-muted">
                      <span *ngIf="skipped.validation_passed" class="text-success">
                        <ng-icon name="lucideCircleCheck" class="me-1"></ng-icon>
                        {{ skipped.reason || 'Validation passed' }}
                      </span>
                      <span *ngIf="!skipped.validation_passed">
                        {{ skipped.reason || 'Skipped due to other errors' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- After import: summary, errors, details -->
  <div *ngIf="showResults">
    <!-- Errors section -->
    <div *ngIf="errors?.length" class="alert alert-danger" role="alert">
      <h5 class="alert-heading mb-0">Errors found</h5>
      <!-- <ul class="mb-0 ps-3">
        <li *ngFor="let e of errors">{{ e }}</li>
      </ul> -->
    </div>

    <!-- Success summary when no errors -->
    <div *ngIf="!errors?.length && !isProcessBackendTask" class="alert alert-primary">
      <h5 class="alert-heading mb-2">
        <ng-icon name="lucideBadgeCheck"></ng-icon>
        Import Completed
      </h5>
      <p class="mb-0">Your Excel file has been processed. See the details below:</p>
    </div>
    <div *ngIf="!errors?.length && isProcessBackendTask" class="alert alert-primary">
      <h5 class="alert-heading mb-2">
        <ng-icon name="lucideBadgeCheck"></ng-icon>
        Import is processing.
      </h5>
      <p class="mb-0">Your Excel file is processing. See the details in the notification section</p>
    </div>

    <!-- Import summary cards -->
    <div class="row g-3 mb-3" *ngIf="importStats">
      <div [ngClass]="isProcessBackendTask ? 'col-md-12' : 'col-md-4'">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0 text-dark">{{ importStats.total_locations_found ?? 0 }}</div>
            <div class="text-muted">Total Locations Found</div>
          </div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isProcessBackendTask">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0 text-dark">{{ importStats.locations_imported?.length || 0 }}</div>
            <div class="text-muted">Locations Imported</div>
          </div>
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isProcessBackendTask">
        <div class="card text-center">
          <div class="card-body">
            <div class="h4 mb-0 text-dark">{{ importStats.locations_skipped?.length || 0 }}</div>
            <div class="text-muted">Locations Skipped</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Locations with validation errors -->
    <div *ngIf="getErrorSkippedLocations($safeNavigationMigration(importStats?.locations_skipped))?.length" class="mb-3">
      <div class="card">
        <div class="card-header bg-danger text-white">Locations with Validation Issues</div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-sm table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>Row</th>
                  <th>IATA</th>
                  <th>Issue</th>
                  <th>Field</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of getErrorSkippedLocations($safeNavigationMigration(importStats?.locations_skipped))">
                  <td>{{ s.row || '-' }}</td>
                  <td><strong>{{ s.iata || s.location || '-' }}</strong></td>
                  <td>{{ s.reason || s.error || '-' }}</td>
                  <td>
                    <ng-container *ngIf="importStats.row_details?.[s.row]?.length; else noField">
                      {{ importStats.row_details[s.row][0]?.field || '-' }}
                    </ng-container>
                    <ng-template #noField>-</ng-template>
                  </td>
                  <td>
                    <ng-container *ngIf="importStats.row_details?.[s.row]?.length; else noVal">
                      {{ importStats.row_details[s.row][0]?.value ?? '-' }}
                    </ng-container>
                    <ng-template #noVal>-</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Notices from importer (e.g., auto-set Yearly Volume for special fuels) -->
    <div *ngIf="importStats?.notices?.length" class="mb-3">
      <div class="card">
        <div class="card-header bg-warning text-dark">Notices</div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-sm table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>Row</th>
                  <th>IATA</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let n of importStats.notices">
                  <td>{{ n.row || '-' }}</td>
                  <td><strong>{{ n.iata || '-' }}</strong></td>
                  <td>{{ n.message || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Valid locations skipped due to other errors -->
    <div *ngIf="getValidSkippedLocations($safeNavigationMigration(importStats?.locations_skipped))?.length" class="mb-3">
      <div class="alert alert-info">
        <h6 class="alert-heading mb-2">
          <ng-icon name="lucideInfo"></ng-icon>
          Valid Locations Skipped
        </h6>
        <p class="mb-2">The following locations had valid data but were skipped because other locations in the file had
          validation errors:</p>
        <div class="card">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-sm table-striped align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Row</th>
                    <th>IATA</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of getValidSkippedLocations($safeNavigationMigration(importStats?.locations_skipped))">
                    <td>{{ s.row || '-' }}</td>
                    <td><strong>{{ s.iata || s.location || '-' }}</strong></td>
                    <td class="text-success">
                      <ng-icon name="lucideCircleCheck" class="me-1"></ng-icon>
                      {{ s.reason || 'Validation passed' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <!-- Initial state - just close button -->
  <button *ngIf="!showResults && !showValidationResults" type="button" class="btn btn-light"
    (click)="close()">Close</button>

  <!-- Validation results state - proceed or cancel buttons -->
  <div *ngIf="showValidationResults" class="d-flex w-100 justify-content-between">
    <button type="button" class="btn btn-light" (click)="cancelImport()">Cancel</button>
    <div>
      <button *ngIf="validationErrors?.length" type="button" class="btn btn-primary" (click)="cancelImport()"
        [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        Try again
      </button>
      <button *ngIf="!validationErrors?.length" type="button" class="btn btn-primary text-white"
        (click)="proceedWithImport()" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        Proceed with Import
      </button>
    </div>
  </div>

  <!-- Import results state - just close button -->
  <div *ngIf="showResults" class="d-flex w-100 justify-content-end">
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
  </div>
</div>
